/**
 * Returns true if the value is empty (object has no non null values )
 *
 * null is the empty value treat it as a value!
 */
export function isEmpty(v: unknown, shallow?: boolean): boolean {
  return (
    v === undefined ||
    (typeof v === "string" && v.trim() === "") ||
    (typeof v === "number" && isNaN(v)) ||
    (!shallow && Array.isArray(v) && !v.some((x) => !isEmpty(x, shallow))) ||
    (!shallow &&
      typeof v === "object" &&
      v !== null &&
      !Object.values(v).some((x) => !isEmpty(x, true)))
  );
}
